module.exports = __webpack_public_path__ + "static/media/mi-14.040241ed.jpg";